import * as React from 'react';
import { ReactMultiEmail } from 'react-multi-email/commonjs';

import * as classes from '@common/components/multi-email-input/multi-email-input.scss';
import 'react-multi-email/style.css';

export interface MultiEmailInputProperties {
  readonly onChange: (emails: string[]) => void;
}

export class MultiEmailInput extends React.Component<MultiEmailInputProperties> {
  public render(): JSX.Element {
    return (
      <div className={classes.multiEmailContainer}>
        <ReactMultiEmail
          // style={myStyle}
          // emails={emails}
          onChange={this.props.onChange}
          getLabel={(email, index, removeEmail) => {
            return (
              <div className={classes.entry} key={index}>
                {email}
                <span className="fas fa-times" onClick={() => removeEmail(index)} />
              </div>
            );
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/multi-email-input/multi-email-input.component.tsx